import React from "react";
import ItemsInBasket from "../component/ItemsInBasket";
import Subtotal from "../component/Subtotal";
import { useStateValue } from "../StateProvider";
import "../styles/CheckOut.css";

function CheckOut() {
  const [{ basket }] = useStateValue();
  return (
    <div className="checkout">
      {basket.length > 0 ? (
        <div className="checkout__left">
          <h2 className="checkout__title">Your Shopping Basket</h2>

          {basket.map((item) => (
            <ItemsInBasket exit={{ y: -1000 }} key={item.key} item={item} />
          ))}
        </div>
      ) : (
        <div className="checkout__empty">
          <h2 className="checkout__emptyText">The Basket Is Empty</h2>
        </div>
      )}

      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
}

export default CheckOut;
